export function getSampleTypesByDeliveryMethod(deliveryMethod, selectedItemList, methodName) {
  let typeSet = new Set();
  ["blood", "nonBlood", "dryIce"].forEach(type => {
    if (deliveryMethod[type] === methodName) {
      selectedItemList.forEach(t => {
        typeSet = new Set([...typeSet, ...t.sampleTypeSets[type]]);
      });
    }
  });
  return [...typeSet];
}